'use client';

import { useEffect } from 'react';

export default function AppError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error('App error boundary caught:', error);
    }, [error]);

    return (
        <div className="min-h-screen bg-[#111118] flex items-center justify-center p-6">
            <div className="text-center max-w-md">
                <div className="w-12 h-12 rounded-full bg-red-500/10 border border-red-500/20 flex items-center justify-center mx-auto mb-4">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-400">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="12" />
                        <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                </div>
                <h2 className="text-lg font-semibold text-white mb-2">Something went wrong</h2>
                <p className="text-sm text-white/40 mb-6">
                    An unexpected error occurred. This is usually temporary.
                </p>
                <button
                    onClick={reset}
                    className="px-5 py-2.5 bg-violet-600 hover:bg-violet-500 text-white text-sm font-medium rounded-lg transition"
                >
                    Try again
                </button>
            </div>
        </div>
    );
}
